import useBoardStore from '../../store/boardStore';

function initials(name) {
  return name ? name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2) : '?';
}

export default function BoardMembers() {
  const { columns, cards, cardValues, users } = useBoardStore();
  const personCol = columns.find((c) => c.type === 'person');

  let assignedIds;
  if (personCol) {
    const ids = new Set();
    for (const card of cards) {
      const v = cardValues[`${card.id}:${personCol.id}`];
      if (v) ids.add(v);
    }
    assignedIds = [...ids];
  } else {
    assignedIds = [...new Set(cards.map((c) => c.created_by).filter(Boolean))];
  }

  const assigned = assignedIds
    .map((id) => users.find((u) => u.id === id))
    .filter(Boolean);

  if (assigned.length === 0) return null;

  const shown = assigned.slice(0, 3);
  const extra = assigned.length - shown.length;

  return (
    <div className="flex items-center -space-x-2">
      {shown.map((u) => (
        <div
          key={u.id}
          className="w-8 h-8 rounded-full bg-accent/20 text-accent flex items-center justify-center text-[11px] font-semibold border-2 border-main"
          title={u.name}
        >
          {u.avatar_url ? (
            <img src={u.avatar_url} alt={u.name} className="w-full h-full rounded-full object-cover" />
          ) : initials(u.name)}
        </div>
      ))}
      {extra > 0 && (
        <div
          className="w-8 h-8 rounded-full bg-white/10 text-text-secondary flex items-center justify-center text-[11px] font-semibold border-2 border-main"
          title={`+${extra} atribuídos`}
        >
          +{extra}
        </div>
      )}
    </div>
  );
}
